export default "どうやって\nなぜ\n幾つか\nいつ\nいくら\nどこから\nは\n何\nとは\n誰が\nどこ\nどれの\nどれ\n違い\nだれの\nする\nした\n持っている\nできる\n意思\nするだろう\nできた\nすべき"